var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5385 27.1549V32.3858C24.5385 33.0795 24.263 33.7448 23.7725 34.2352C23.282 34.7257 22.6168 35.0013 21.9232 35.0013H3.61539C2.92174 35.0013 2.25651 34.7257 1.76603 34.2352C1.27555 33.7448 1 33.0795 1 32.3858V3.61549C1 2.92181 1.27555 2.25656 1.76603 1.76606C2.25651 1.27556 2.92174 1 3.61539 1H21.9232C22.6168 1 23.282 1.27556 23.7725 1.76606C24.263 2.25656 24.5385 2.92181 24.5385 3.61549V8.84646",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0013 18.0005H14.0781",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3089 12.7695L14.0781 18.0005L19.3089 23.2315",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayInIcon);
export default __webpack_public_path__ + "static/media/PayInIcon.e161a69448ada3a32b637f9daac76696.svg";
export { ForwardRef as ReactComponent };